// "Saved decks of this account were written OUTSIDE useSavedDecks": the
// deck-box runner commits saved decks on the server (the commit RPC), so no
// useSavedDecks instance saw the write. Every mounted cloud list for that
// user re-reads in the background (coalesced with any load in flight).
//
// Sent by the deck-box runner after every commit and once when a batch
// finishes (deck-boxes client plan 10 nits). A plain module, no React.

type Listener = (userId: string) => void
const listeners = new Set<Listener>()

export function notifySavedDecksChangedRemotely(userId: string): void {
  for (const l of [...listeners]) {
    try { l(userId) } catch { /* one listener never stops another */ }
  }
}

/** Subscribe; returns the unsubscribe. */
export function onSavedDecksChangedRemotely(listener: Listener): () => void {
  listeners.add(listener)
  return () => { listeners.delete(listener) }
}
